import React from 'react';
import StackView from '../StackView';

function PageToolbar(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(StackView, {
    grow: 1,
    axis: "horizontal",
    alignment: "start",
    distribution: "space-between"
  }, children);
}

export default PageToolbar;